<template>
  <tr>
    <td>
      <div class="row-block">
        <div class="image-holder">
          <img
            class="logo"
            :src="logo"
            alt="user_logo">
          <img
            v-if="isLead"
            class="trophy"
            src="/static/images/elements/analytics/trophy.svg"
            alt="Trophy icon"
          >
        </div>
        {{ name }}
      </div>
    </td>
    
    <td
      v-for="(cell, index) in values"
      :key="index"
    >
      {{ cell.value.value }}
      <span class="line" :style="{ width: cell.value.percent * 1.12 + 'px' }"></span> 
    </td>
  </tr>
</template>

<script>
export default {
  name: 'analytics-recruiter-row',

  props: {
    recruiter: Object
  },

  computed: {
    userInfo () {
      return this.cells && this.cells.length > 0 ? this.cells[0].value : null
    },

    logo () {
      const logo = this.userInfo ? this.userInfo.logo : null

      return logo || '/static/images/elements/man.png'
    },

    isLead () {
      return this.userInfo ? this.userInfo.is_lead : false
    },

    cells () {
      return this.recruiter ? this.recruiter.cells : null
    },

    name () {
      if (!this.userInfo) {
        return '';
      }

      return !this.is_japan_locale ? `${this.userInfo.name} ${this.userInfo.surname}` : `${this.userInfo.surname} ${this.userInfo.name}`;
    },

    is_japan_locale() {
      return this.$store.getters['locale/is_japan_locale'];
    },

    values () {
      if (!this.cells) {
        return []
      }
      // slice first cell with info about user
      return this.cells ? this.cells.slice(1) : []
    }
  }
}
</script>

<style lang="scss" scoped>
  tr {
    &:hover {
      background: #F1F2F2;
    }

    td {
      padding: 9px 8px;
      font-size: 16px;
      color: #000000;

      &.avatar {
        padding-left: 23px;
        padding-right: 2px;
      }

      &:nth-child(n + 2) {
        padding-left: 0;
      }

      .image-holder {
        position: relative;
        width: 40px;
        height: 40px;
        margin-right: 17px;

        .logo {
          width: 40px;
          height: 40px;
          box-sizing: border-box;
          border-radius: 50%;
          border: 1px solid rgba(204, 204, 204, 0.5);
        }

        .trophy {
          position: absolute;
          right: 0;
          bottom: 0;
        }
      }

      .line {
        display: inline-block;
        margin-left: 5px;
        height: 15px;
        background: #69C758;
        min-width: 2px;
      }
    }
  }
</style>
